<template>
    <BaseModal :title="'Nft/Token'" @close="closeModal">
        <template #modalContent>
            <div class="modal-content-wrapper">
                <div class="modal-content">
                    <div class="modal-heading">
                        <h3>Edit NFT/Token</h3>
                    </div>
                    <div class="flex flex-col w-full items-start justify-start gap-6 mb-16">
                        <div class="flex flex-col gap-2 w-full pt-6">
                            <p>drop.type</p>
                            <button class="basic_btn_ p-1 px-2" :class="{ 'active-btn': nftIsChecked }"
                                @click="togglePublicSwitch">NFTs</button>
                            <button class="basic_btn_ p-1 px-2"
                                :class="{ 'active-btn': tokenIsChecked }">Tokens</button>
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>nft.distribute</p>
                            <button class="basic_btn_ p-1 px-2" :class="{ 'active-btn': public_nft_flow }"
                                @click="togglePublicSwitch">
                                Public
                            </button>
                            <button class="basic_btn_ p-1 px-2" :class="{ 'active-btn': !public_nft_flow }"
                                @click="togglePrivateSwitch">
                                Private
                            </button>
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>network.select</p>
                            <select class="w-2/5 p-3 mt-2" name="network-select" id="network-select" v-model="network"
                                @change="updateNetwork">
                                <option value="41">Telos EVM Testnet</option>
                                <option value="1">Ethereum</option>
                                <option value="5">Goerli Testnet RPC</option>
                                <option value="137">Polygon</option>
                                <option value="40">Telos EVM Mainnet</option>
                                <option value="11155111">Sepolia</option>
                                <option value="11155420">OP Sepolia</option>
                            </select>
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>contract.address</p>
                            <input class="w-2/5 p-3 mt-2" type="text" id="contract_address" v-model="contract_address"
                                v-on:change="valueCheck()" @keyup="valueCheck()"
                                placeholder=" ex: 0x0710A4F91Dfa5c88A81A5b7a767" />
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>ABI</p>
                            <textarea class="w-3/5 p-2 mt-2" id="aib" v-model="aib" v-on:change="valueCheck()"
                                @keyup="valueCheck()" placeholder='ex: [{"internalType": "uint256}]'></textarea>
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>parameters</p>
                            <input class="w-2/5 p-3 mt-2" type="text" id="parameter" v-model="parameter"
                                v-on:change="valueCheck()" @keyup="valueCheck()" placeholder="ex: {_count:1}" />
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>mintFunction.name</p>
                            <input class="w-2/5 p-3 mt-2" type="text" placeholder=" ex: mintNFTs"
                                id="mint_function_name" v-model="mint_function_name" v-on:change="valueCheck()"
                                @keyup="valueCheck()" />
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>price</p>
                            <input class="w-2/5 p-3 mt-2" v-model="price" v-on:change="valueCheck()"
                                @keyup="valueCheck()" />
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>description</p>
                            <input class="w-2/5 p-3 mt-2" id="nft_description" placeholder="ex. utility of the NFT"
                                v-model="nft_description" v-on:change="valueCheck()" @keyup="valueCheck()" />
                        </div>

                        <div class="flex flex-col gap-2 w-full">
                            <p>Upload NFT</p>
                            <div>
                                <!-- Hidden File Input -->
                                <input type="file" class="hidden" name="Sample nft" id="nft_image" ref="nft_image"
                                    accept="image/*" v-on:change="uploadSampleNft" />
                                <button v-if="!selectedFile" @click="openUpload"
                                    class="basic_up_btn_ w-2/5 mt-2 flex items-center justify-between p-3 text-left">/*
                                    <br>
                                    Click to upload file<br />
                                    or drag and drop your file <br> */
                                    <span>
                                        <svg width="20" height="20" viewBox="0 0 29 29" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M13.3846 8.9232H15.6154V13.3847H20.0769V15.6155H15.6154V20.077H13.3846V15.6155H8.92308V13.3847H13.3846V8.9232Z"
                                                fill="#64748B" />
                                            <path d="M2.23077 0.00012207V2.23089H26.7692V0.00012207H2.23077Z"
                                                fill="#64748B" />
                                            <path d="M29 2.23089H26.7692V26.7694H29V2.23089Z" fill="#64748B" />
                                            <path d="M2.23077 26.7694V29.0001H26.7692V26.7694H2.23077Z"
                                                fill="#64748B" />
                                            <path d="M0 26.7694H2.23077V2.23089H0V26.7694Z" fill="#64748B" />
                                        </svg>
                                    </span>
                                </button>
                                <!-- Image Preview (Replaces Input) -->
                                <div v-else style="position: relative; display: inline-block;">
                                    <img :src="selectedFile" alt="NFT Preview"
                                        style="max-width: 120px; max-height: 120px; display: block; border: 2px solid #ccc; border-radius: 5px;" />
                                    <button @click="removeImage" style="position: absolute;
                                        top: -10px;
                                        right: -10px;
                                        width: 24px;
                                        height: 24px;
                                        border-radius: 50%;
                                        background: red;
                                        color: white;
                                        font-size: 16px;
                                        font-weight: bold;
                                        border: none;
                                        cursor: pointer;
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);">
                                        x
                                    </button>
                                </div>
                                <p style="max-width: 120px; overflow: hidden">{{ sampleName }}</p>
                            </div>
                        </div>
                        <div>
                            <vs-button @click.stop="addNft(true)" class="mt-8" type="border"> >>Update NFT</vs-button>
                        </div>
                    </div>
                </div>
                <div class="cast-modal-bottom">
                    <p>>> Update Drops</p>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import axios from '@/axios';
import constants from '../../../../constant';
import BaseModal from "@/components/common/BaseModal.vue";

export default {
    name: 'EditNftModal',
    props: ['closeModal', 'castDetails', 'getCastList'],
    components: {
        BaseModal,
    },
    data() {
        return {
            nftIsChecked: true,
            tokenIsChecked: false,
            sampleName: 'No File Selected',
            dummyURI: '',
            selectedFile: null,
            nftDetails: null,

            //requiredNftDetails for payload
            audienceAirdrop: true,
            public_nft_flow: true,
            mint_function_name: '',
            contract_address: '',
            aib: '',
            parameter: '',
            network: '',
            nft_image: '',
            nft_type: 'NFTs',
            nft_description: '',
            price: '',
            give_nft: false,
            give_vc: false,

            //other data
            mintfnc_name_error: false,
            contract_address_error: false,
            aib_error: false,
            airdropType: 'NFTs',
            nft_description_error: false,
            nft_image_error: false,
            meeting_type: 'public',
            description: '',
        };
    },
    mounted() {
        this.meeting_type = this.castDetails.cast_type ? this.castDetails.cast_type : this.castDetails.type;
        if (this.castDetails.public_meeting_id === 'vw.svg') {
            return;
        }
        this.getNFTDetails();
    },
    methods: {
        getNFTDetails() {
            // this.$vs.loading();
            document.getElementById('loading-bg-transparent-title').innerText = '🔍 Fetching NFT drop details';
            document.getElementById('loading-bg-transparent').style.display = 'flex';
            const payload = this.castDetails.public_meeting_id ? this.castDetails.public_meeting_id : this.castDetails.meeting_id;
            this.$store
                .dispatch('cast/recieveNFTDetails', payload)
                .then((res) => {
                    this.nftDetails = res.data;
                    this.public_nft_flow = res.data.pub_nft_flow;
                    this.mint_function_name = res.data.mint_function_name;
                    this.contract_address = res.data.contract_adress;
                    this.nft_description = res.data.description;
                    this.network = res.data.network;
                    this.parameter = JSON.stringify(res.data.parameter);
                    this.aib = JSON.stringify(res.data.aib);
                    this.image = res.data.image;
                    this.nft_image = res.data.image;
                    this.selectedFile = res.data.image;
                    this.price = res.data.price;
                    this.give_nft = res.data.pub_nft_flow ? false : this.meeting_type === 'public' ? false : true;
                    const imageUrl = res.data.image;
                    const url = new URL(imageUrl);
                    const imageName = url.pathname.split('/').pop();
                    this.sampleName = imageName;
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                })
                .catch((e) => {
                    console.log('error in receibing', e);
                });
        },
        togglePrivateSwitch() {
            this.public_nft_flow = false;
        },
        togglePublicSwitch() {
            this.public_nft_flow = true;
        },
        updateNetwork(event) {
            this.network = event.target.value;
        },
        valueCheck(e) {
            if (
                this.audienceAirdrop &&
                this.airdropType === 'NFTs'
            ) {
                if (this.mint_function_name.length !== 0)
                    this.mintfnc_name_error = false;
                if (this.contract_address.length !== 0)
                    this.contract_address_error = false;
                if (this.aib.length !== 0)
                    this.aib_error = false;
                if (this.nft_description.length !== 0)
                    this.nft_description_error = false;
                if (this.nft_image !== '')
                    this.nft_image_error = false;
            }
        },
        openUpload() {
            document.getElementById('nft_image').click();
        },
        canSubmitNft() {
            if (
                this.audienceAirdrop &&
                this.airdropType === 'NFTs' &&
                (this.mint_function_name === '' ||
                    this.contract_address === '' ||
                    this.aib === '' ||
                    this.nft_description === '' ||
                    this.nft_image === '')
            ) {
                if (
                    this.audienceAirdrop &&
                    this.airdropType === 'NFTs'
                ) {
                    this.mintfnc_name_error =
                        this.mint_function_name === '';
                    this.contract_address_error =
                        this.contract_address === '';
                    this.aib_error = this.aib === '';
                    this.nft_image_error =
                        this.nft_image === '';
                    this.nft_description_error =
                        this.nft_description === '';
                }
                this.$vs.notify({
                    time: 3000,
                    title: 'Cannot Submit',
                    text: 'Please fill the fields which are required.',
                    color: 'danger',
                });
                return false;
            } else {
                return true;
            }
        },

        async addNft(x) {
            if (!this.public_nft_flow && this.meeting_type === 'public') {
                this.$vs.notify({
                    title: 'Action required',
                    text: 'Please collect attendee emails or stream privately before changing to private NFT.',
                    color: 'warning',
                });
                return;
            }

            if (this.canSubmitNft()) {
                try {
                    const payload = new FormData();
                    payload.append('audienceAirdrop', this.audienceAirdrop ? 'True' : 'False');
                    payload.append('public_nft_flow', this.public_nft_flow ? 'True' : 'False');
                    payload.append('mint_function_name', this.mint_function_name);
                    payload.append('contract_address', this.contract_address);
                    payload.append('aib', this.aib);
                    payload.append('parameter', this.parameter);
                    payload.append('network', this.network);
                    payload.append('nft_image', this.nft_image);
                    payload.append('nft_type', this.nft_type);
                    payload.append('nft_description', this.nft_description);
                    payload.append('price', this.price);
                    payload.append('give_nft', this.public_nft_flow ? 'False' : this.meeting_type === 'public' ? 'False' : 'True');
                    payload.append('give_vc', this.give_vc ? 'True' : 'False');

                    const castId = this.castDetails.public_meeting_id ? this.castDetails.public_meeting_id : this.castDetails.meeting_id;
                    payload.append('public_meeting_id', castId);
                    // this.$vs.loading();
                    document.getElementById('loading-bg-transparent-title').innerText = '🔄 Updating Airdrop details';
                    document.getElementById('loading-bg-transparent').style.display = 'flex';
                    await this.$store.dispatch('studio/updateNftDetails', payload);
                    if (x) {
                        this.$vs.notify({
                            time: 6000,
                            title: 'Airdrop Details Updated',
                            color: 'success',
                        });

                        // this.$vs.loading.close();
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                        this.getCastList();
                        this.closeModal();
                    }
                } catch (error) {
                    // this.$vs.loading.close();
                    document.getElementById('loading-bg-transparent').style.display = 'none';
                    console.log(JSON.stringify(error));

                    if (error.response) {
                        console.log(error.response);
                        // this.$vs.loading.close();
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                        this.$vs.notify({
                            time: 6000,
                            title: 'Error',
                            text: error.response.data.message,
                            color: 'danger',
                        });
                    }
                }
            }
        },

        resetFields() {
            this.contract_address = '';
            this.contract_address_error = false;
            this.aib = '';
            this.aib_error = false;
            this.parameter = '';
            this.mint_function_name = '';
            this.mintfnc_name_error = false;
            this.price = '';
            this.nft_description = '';
            this.nft_image_error = false;
            this.sampleName = 'No file selected';
            this.$refs.nft_image.value = '';
        },
        uploadSampleNft(event) {
            if (event.target.files.length > 0) {
                this.nft_image = event.target.files[0];
                this.selectedFile = URL.createObjectURL(this.nft_image);
                this.sampleName = event.target.files[0].name;
                this.nft_image_error = false;
            } else {
                this.nft_image_error = true;
                this.selectedFile = null;
                this.sampleName = 'No file selected';
                this.nft_image = null;
            }
        },
        removeImage() {
            this.nft_image = null;
            this.selectedFile = null;
            this.sampleName = 'No File Selected';
            this.nft_image_error = false;
        }
    },
}
</script>

<style scoped>
.basic_btn_ {
    background: none;
    border: 1px solid #FFFFFF;
    width: 100px;
    text-align: left;
    color: #FFFFFF;
    cursor: pointer;
}

.basic_up_btn_ {
    color: #5B96EB;
    background: none;
    border: 1px dotted #FFFFFF;
    cursor: pointer;
}

input {
    font-family: 'JetBrains Mono';
    border: 0px;
    background-color: #FFFFFF;
    outline: none;
    border-radius: 0px;
    color: #000000;
    font: bold !important;
}

#aib {
    resize: none;
    height: 100px !important;
}

.active-btn {
    background: #22C55E;
    color: #000000;
    font: bold;
}
</style>